// components/ErrorModal.tsx
'use client'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { AlertCircle } from 'lucide-react'

interface ErrorModalProps {
    isOpen: boolean
    message: string
    onClose: () => void
}

export default function ErrorModal({ isOpen, message, onClose }: ErrorModalProps) {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/50" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-8 text-left align-middle shadow-xl transition-all">
                                <div className="flex flex-col items-center">
                                    <AlertCircle className="h-16 w-16 text-red-500 mb-4 stroke-[1.5]" />
                                    <Dialog.Title
                                        as="h3"
                                        className="text-2xl font-bold leading-6 text-gray-900 mb-4"
                                    >
                                        LỖI
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <p className="text-xl text-gray-700 text-justify whitespace-pre-line">
                                            {message.replace(/<br\s*\/?>/gi, '\n')}
                                        </p>
                                    </div>
                                </div>

                                <div className="mt-8 flex justify-center">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center rounded-md border border-transparent bg-red-600 px-8 py-3 text-xl font-medium text-white hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                                        onClick={onClose}
                                    >
                                        ĐÃ HIỂU
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}